//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GallerySearch from "./GallerySearch";
import FiltersBox from "./FiltersBox.vue";
import Sorting from "./Sorting.vue";
import {getContentByCode} from "../../utils/utils";

export default {
  components: {
    Sorting,
    FiltersBox,
    GallerySearch,
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      parametersActive: !this.$route.query.hasOwnProperty("search"),
    };
  },
  methods: {
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    },
    resetAllFilter () {
      const query = {...this.$route.query}
      const types = ['category', 'period', 'author', 'loyalty', 'canPatron', 'style']
      Object.getOwnPropertyNames(query).forEach(key => {
        if(types.includes(key)) {
          delete query[key]
        }
      });

      delete query.sort
      delete query.order

      this.$router.push({
        path: this.$route.path,
        query
      })
    }
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'sorting-texts',
        auto: true,
        params: {
          code: ['sort', 'resetfilter'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
};
